/*
 * Filename: formula-field.model.ts
 * Error store: This file represents the model for templates that will be displayed on homepage.
 */

import { types, ModelInstanceTypeProps, ModelProperties } from 'mobx-state-tree';


export const FormulaFieldData = types.model({
    FormulaFieldData: types.optional(types.frozen(), {}),
    selectedFormulaFieldValue: types.optional(types.frozen(), {})
}).actions((self: ModelInstanceTypeProps<ModelProperties>) => ({

    deleteFormulaField(objectName: string) {
        let existingFormulaFieldObject = { ...self.FormulaFieldData };
        delete existingFormulaFieldObject[objectName];
        self.FormulaFieldData = existingFormulaFieldObject;

    },
    addEditFormulaField(objectName: string, dynamicSource: any) {
            if (self.FormulaFieldData.hasOwnProperty(objectName)) {
                const formulaFieldData = { ...self.FormulaFieldData };
                delete formulaFieldData[objectName];
                self.FormulaFieldData = { ...formulaFieldData, [objectName]: dynamicSource[objectName] };
            }
            else {
                let formulaFieldData = { ...self.FormulaFieldData };
                formulaFieldData = { ...formulaFieldData, [objectName]: dynamicSource[objectName] };
                self.FormulaFieldData = formulaFieldData;
            }

    },
    setSelectedFormulaFieldValue(objectName:string){
        if(self.FormulaFieldData.hasOwnProperty(objectName)){
            const value = self.FormulaFieldData[objectName];
            self.selectedFormulaFieldValue = value;
        } else{
            self.selectedFormulaFieldValue = {}
        }
    }
}));
